import { Maximize2 } from "lucide-react-native";
import React from "react";
import { Text, View } from "native-base";
import { AutoHeighImage } from "../../../../Universal/Image/AutoWidthImage";
import PressableWrap from "../../../../Universal/Buttons/PressableColorWrap/PressableColorWrap";
import PressableWrapp from "../../../../Universal/Buttons/PressableReact/PressableWrapp";
import ImageSwiper from "../../../ImageSwiper/ImageSwiper";
import GalleryThumbnailRail from "./ThumbnailRail";
import { UnitFullV2GalleryProps } from "./types";

const UnitFullV2Gallery: React.FC<UnitFullV2GalleryProps> = ({
  currentIndex,
  currentUnit,
  galleryImages,
  heroWidth,
  imageSwiperRef,
  isSmallVersion,
  layout,
  scaleAll,
  styles,
  thumbImages,
  onIndexChange,
  onOpenExpanded,
}) => (
  <View style={styles.galleryCard}>
    {galleryImages.length > 0 ? (
      <>
        <View style={styles.galleryTopBar}>
          <Text style={styles.galleryTopBarText}>Галерея продукта</Text>
          <PressableWrapp
            style={[
              styles.galleryExpandPill,
              isSmallVersion ? styles.galleryExpandPillSmall : null,
            ]}
            onPress={() => onOpenExpanded(currentIndex)}
          >
            <Maximize2 size={15 * scaleAll} color="#111111" />
            <Text style={styles.galleryExpandPillText}>
              {isSmallVersion ? "Fullscreen" : "Открыть"}
            </Text>
          </PressableWrapp>
        </View>

        {galleryImages.length > 1 ? (
          <View style={styles.imageCounter}>
            <Text style={styles.imageCounterText}>
              {currentIndex + 1} / {galleryImages.length}
            </Text>
          </View>
        ) : null}

        {currentUnit.sliders.full?.length > 0 ? (
          <>
            <ImageSwiper
              ref={imageSwiperRef}
              images={galleryImages}
              slideWidth={heroWidth}
              onPress={({ index }) => onOpenExpanded(index)}
              onIndexChange={({ index }) => onIndexChange(index)}
            />
            <GalleryThumbnailRail
              currentIndex={currentIndex}
              imageSwiperRef={imageSwiperRef}
              isSmallVersion={isSmallVersion}
              scaleAll={scaleAll}
              styles={styles}
              thumbImages={thumbImages}
            />
          </>
        ) : (
          <PressableWrap onPress={() => onOpenExpanded(0)}>
            <AutoHeighImage
              width={heroWidth}
              scaleAll={scaleAll}
              source={{ uri: currentUnit.uri_full }}
              maxHeight={layout.canUseWideLayout ? 680 : 460}
            />
          </PressableWrap>
        )}

        <View style={styles.galleryFooterBar}>
          <Text
            style={[
              styles.galleryFooterText,
              isSmallVersion ? styles.galleryFooterTextSmall : null,
            ]}
          >
            Нажмите на изображение, чтобы открыть его в полном размере
          </Text>
        </View>
      </>
    ) : (
      <View style={styles.emptyGallery}>
        <Text style={styles.emptyGalleryText}>Изображение скоро появится</Text>
      </View>
    )}
  </View>
);

export default React.memo(UnitFullV2Gallery);
